export async function DiagramForms() {
    // Return focus to search input if they use clear button
    $('form[role="search"]').on('reset', function (event) {
        event.preventDefault(); // handle this manually (in case there's a value set already, i.e. on the search results page)
        $('input[type="search"]', this).val('').focus();
    })
}